import Mortality from './Mortality';

export default Mortality;
